module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/column-3-678836d51d5d09806066ee8a14bb5f37.svg";